import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { APP_NAME } from '@/constants/brand';
import { getRouteMeta } from '@/constants/routes';

export function DocumentTitleProvider() {
  const location = useLocation();

  useEffect(() => {
    const meta = getRouteMeta(location.pathname);
    const title = meta?.documentTitle ?? 'Admin';
    document.title = `${title} | ${APP_NAME}`;
  }, [location.pathname]);

  return <Outlet />;
}
